import useLazySelector from "common/redux/useLazySelector";
import * as MerchantActions from 'features/merchants/merchants.actions';
import { CustomField } from "domain/customField";

export default function useCustomFields(): CustomField[] {
    return useLazySelector(store => store.customFields, MerchantActions.loadMerchantCustomFields, null, []);
}